import { ComplianceForm } from '@/shared/modules/typescript-trustapi-client/models';
import { Module } from "vuex";

const complianceFormStoreModule: Module<any, any> = {
  state: {
    selectedComplianceFormA: null,
    selectedComplianceFormB: null,
    selectedComplianceFormEER: null,
    formUpdatingkey: sessionStorage.getItem('formUpdatingkey') || null,
  },
  mutations: {
    setSelectedComplianceFormA(state, i: ComplianceForm) {
      state.selectedComplianceFormA = i;
    },
    setSelectedComplianceFormB(state, i: ComplianceForm) {
      state.selectedComplianceFormB = i;
    },
    setSelectedComplianceFormEER(state, i: ComplianceForm) {
      state.selectedComplianceFormEER = i;
    },
    setFormUpdatingkey(state, i: string) {
      sessionStorage.setItem('formUpdatingkey', i);
      state.formUpdatingkey = i;
    }
  },
  actions: {
    setSelectedComplianceFormA({ commit }, i: ComplianceForm) {
      commit('setSelectedComplianceFormA', i);
    },
    setSelectedComplianceFormB({ commit }, i: ComplianceForm) {
      commit('setSelectedComplianceFormB', i);
    },
    setSelectedComplianceFormEER({ commit }, i: ComplianceForm) {
      commit('setSelectedComplianceFormEER', i);
    },
    setFormUpdatingkey({ commit }, i: string) {
      commit('setFormUpdatingkey', i);
    }
  },
  getters: {
    getSelectedComplianceFormA: (state) => state.selectedComplianceFormA,
    getSelectedComplianceFormB: (state) => state.selectedComplianceFormB,
    getSelectedComplianceFormEER: (state) => state.selectedComplianceFormEER,
    getFormUpdatingKey: (state) => state.formUpdatingkey,
  }
}
export default complianceFormStoreModule;
